import React from "react";
import { Link } from "react-router-dom";

export const InfoCounters = props =>
  <div className="row row-sm mb-1">
    {props.counters.map((counter, index) =>
      <div className="col-xxs-6 col-xs-6 col-sm-3">
        <div className="box box-stat">
          <div className="d-flex">
            <h5>{counter.title}</h5>
            <i className="info-icon ml-auto mt-0 tooltip tooltip-left" data-tooltip={counter.info}></i>
          </div>
          <span className="stat-number color-categorical-7 py-1 p-sm-2 mb-sm-1">{counter.count}</span>
          <div className="text-center text-sm-right mt-1 mt-sm-0">
            <Link to={counter.location}><small>Go to {counter.title}</small></Link>
          </div>
        </div>
      </div>)}
  </div>
